import * as Tone from 'tone';

// Wraps Tone.Transport. The scheduler is generic — it just fires a tick at
// each 16th note with the current step index. Triggering instruments based
// on the active pattern is done in the tick handler the app installs.

export function createScheduler(bus) {
    let scheduleId = null;
    let stepIndex = 0;
    let tickHandler = null;

    function play() {
        if (Tone.Transport.state === 'started') return;
        stepIndex = 0;
        scheduleId = Tone.Transport.scheduleRepeat((time) => {
            if (tickHandler) tickHandler(stepIndex, time);
            stepIndex += 1;
        }, '16n');
        Tone.Transport.start();
        bus.emit('transport:started');
    }

    function pause() {
        Tone.Transport.pause();
        bus.emit('transport:paused');
    }

    function stop() {
        Tone.Transport.stop();
        if (scheduleId !== null) {
            Tone.Transport.clear(scheduleId);
            scheduleId = null;
        }
        stepIndex = 0;
        bus.emit('transport:stopped');
    }

    function isPlaying() { return Tone.Transport.state === 'started'; }
    function getStep() { return stepIndex; }
    function setStep(s) { stepIndex = s; }

    function setBPM(bpm) { Tone.Transport.bpm.value = bpm; bus.emit('transport:bpmChanged', bpm); }
    function getBPM() { return Tone.Transport.bpm.value; }

    function setTickHandler(fn) { tickHandler = fn; }

    return { play, pause, stop, isPlaying, getStep, setStep, setBPM, getBPM, setTickHandler };
}
